import { render, staticRenderFns } from "./CardUserFather.vue?vue&type=template&id=6b0770cd"
import script from "./CardUserFather.vue?vue&type=script&lang=js"
export * from "./CardUserFather.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports